<template>
  <div class="post-bottom-container">
    <div class="tags-themes-sentiment-container">
      <div class="polarity-container">
        <span>
          {{ this.$t('components.OperatorsLogs.polarity') }}
        </span>
        <span
          :key="key"
          v-tooltip="polarities"
          :value="value"
          class="polarity-label text-truncate"
        > {{ polarity }}</span>
      </div>
      <div class="tags-theme-container">
        <v-combobox
          v-model="tags"
          :label="$t('components.OperatorsLogs.tag')"
          small-chips
          multiple
          disabled
          outlined
          dense
        />
      </div>
      <div class="themes-container">
        <v-combobox
          v-model="themes"
          :label="$t('components.OperatorsLogs.theme')"
          small-chips
          multiple
          disabled
          outlined
          dense
        />
      </div>
    </div>
    <div class="social-metrics-container">
      <PostIconAndTextMetric
        v-for="(metric, index) in metrics"
        :key="index"
        :metric="metric"
        :value="post[metric] || 0"
      />
    </div>
  </div>
</template>

<script>

import PostIconAndTextMetric from '@/components/Post/PostIconAndTextMetric';
import sentimentModel from '@/mixins/sentiment-model';

export default {
  name: 'PostBottom',
  components: {
    PostIconAndTextMetric,
  },
  mixins: {
    sentimentModel,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    isPostWithImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      maxTags: 3,
      maxThemes: 5,
      metrics: ['likes', 'shares', 'comments', 'videoplays', 'followers'],
    };
  },
  computed: {
    polarities() {
      return {
        0: this.$t('components.OperatorsLogs.polarityTypes.0'),
        1: this.$t('components.OperatorsLogs.polarityTypes.1'),
        2: this.$t('components.OperatorsLogs.polarityTypes.2'),
        3: this.$t('components.OperatorsLogs.polarityTypes.3'),
      };
    },
    tags() {
      return Object.assign([], this.post.tags).splice(0, this.maxTags);
    },
    themes() {
      return Object.assign([], this.post.themes).splice(0, this.maxThemes);
    },
    polarity() {
      return this.polarities[(this.post.polarity)];
    },
  },
};
</script>

<style scoped lang="scss">
  .post-bottom-container {
    display: grid;
    grid-template-rows: 65px 73px;
  }

  .tags-themes-sentiment-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .tags-theme-container {
    border-bottom: 1px solid var(--gray-400);
    display: grid;
    justify-content: center;
    grid-template-rows: 25px 40px;
  }

  .themes-container {
    border-bottom: 1px solid var(--gray-400);
    display: flex;
    justify-content: center;
  }

  .polarity-container {
    border-bottom: 1px solid var(--gray-400);
    display: grid;
    justify-content: center;
    grid-template-rows: 25px 40px;
  }

  .polarity-label {
    text-align: center;
  }

  .social-metrics-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    justify-content: center;
    align-items: center;
  }
</style>
